import { IPoolTemplateType } from "@services/pooltemplates";
import {
  ActionAddPoolTemplates,
  ActionDeletePoolTemplates,
  ActionPoolTemplatesBase,
  ActionPoolTemplatesTypes,
  ActionSetPoolTemplates,
} from "./actions";

interface IStore {
  templates: IPoolTemplateType[];
}

const initialState: IStore = {
  templates: [],
};

const reducer = (state = initialState, action: ActionPoolTemplatesBase) => {
  switch (action.type) {
    case ActionPoolTemplatesTypes.ACTION_SET_POOL_TEMPLATES:
      return {
        ...state,
        templates: (action as ActionSetPoolTemplates).payload,
      };
    case ActionPoolTemplatesTypes.ACTION_ADD_POOL_TEMPLATE:
      return {
        ...state,
        templates: [
          ...state.templates,
          (action as ActionAddPoolTemplates).payload,
        ],
      };

    case ActionPoolTemplatesTypes.ACTION_DELETE_POOL_TEMPLATE: {
      return {
        ...state,
        templates: state.templates.filter(
          (t) => t.Id !== (action as ActionDeletePoolTemplates).payload
        ),
      };
    }

    default:
      return state;
  }
};

export default reducer;
